module.exports = __webpack_public_path__ + "img/bilge-pump-on-icon.c0925bbb.svg";